export interface SubmoduloRutaItem {
  idSubmodulo: number;
  nombreSubmodulo: string;
  idModulo: number;
  nombreModulo: string;
}

export interface GroupedSelectItem {
  value: string;
  label: string;
}

export interface GroupedSelectGroup {
  id: string | number;
  label: string;
  items: GroupedSelectItem[];
}

export function buildGroupedSelectFromSubmodulos(submodulos: SubmoduloRutaItem[]): GroupedSelectGroup[] {
  const groupsMap = new Map<number, GroupedSelectGroup>();

  submodulos.forEach((submodulo) => {
    if (!groupsMap.has(submodulo.idModulo)) {
      groupsMap.set(submodulo.idModulo, {
        id: submodulo.idModulo,
        label: submodulo.nombreModulo,
        items: [],
      });
    }

    groupsMap.get(submodulo.idModulo)?.items.push({
      value: String(submodulo.idSubmodulo),
      label: submodulo.nombreSubmodulo,
    });
  });

  return Array.from(groupsMap.values());
}

export function getGroupedSelectDisplayValue(groups: GroupedSelectGroup[], selectedValue: string | null | undefined): string {
  if (!selectedValue) {
    return '';
  }

  for (const group of groups) {
    const item = group.items.find((entry) => entry.value === selectedValue);
    if (item) {
      return `${group.label} - ${item.label}`;
    }
  }

  return '';
}

export function filterGroupedSelectGroups(groups: GroupedSelectGroup[], searchTerm: string): GroupedSelectGroup[] {
  const normalizedSearch = searchTerm.trim().toLowerCase();
  if (!normalizedSearch) {
    return groups;
  }

  return groups
    .map((group) => {
      const groupMatches = group.label.toLowerCase().includes(normalizedSearch);
      const filteredItems = group.items.filter(
        (item) =>
          item.label.toLowerCase().includes(normalizedSearch) || `${group.label} - ${item.label}`.toLowerCase().includes(normalizedSearch),
      );

      if (groupMatches) {
        return group;
      }

      if (filteredItems.length === 0) {
        return null;
      }

      return { ...group, items: filteredItems };
    })
    .filter((group): group is GroupedSelectGroup => !!group);
}
